export type IncidentPanel = 'dataPanel' | 'map' | 'videoPanel' | 'chat';

export const INCIDENT_PANEL_CSS_CLASS: Record<IncidentPanel, string> = {
  dataPanel: 'active-data-panel',
  map: 'active-map',
  videoPanel: 'active-video-panel',
  chat: 'active-chat',
};
